import { QueryLoader } from "@Light/components/app/QueryLoader";
import { useLocation } from "@Light/components/page/account";
import {
  useHeaderBackNavigate,
  useHeaderTitle,
} from "@Light/components/page/header/context";
import { useScaffold } from "@Light/scaffold";
import { useLight } from "@Light/services/light";
import { useParams } from "@Light/utils/context";
import { formatBrandedPlanName } from "@Light/utils/formatting";
import clsx from "clsx";
import dayjs from "dayjs";
// eslint-disable-next-line no-restricted-imports
import { useMemo } from "react";
import { DocumentList } from "./DocumentList";

export const DocumentsSet: React.FC = () => {
  useHeaderBackNavigate("/account/documents/");

  const { documentsUUID } = useParams();

  const { useGetAllLocationsDocumentsQuery } = useLight();
  const { uuid } = useLocation();
  const allDocuments = useGetAllLocationsDocumentsQuery({ uuid });
  const scaffold = useScaffold();

  const documents = allDocuments.data?.data.find(
    (docSet) => docSet.uuid === documentsUUID,
  );

  const { plan_name, contract_start, contract_end } = documents || {};
  const planName = plan_name && formatBrandedPlanName(scaffold.page, plan_name);

  // Title must be manually memoized to avoid infinite render loop in useHeaderTitle
  const title = useMemo(() => {
    if (!planName) return null;
    return (
      <div className="flex flex-col items-center">
        <div>{planName}</div>
        <div
          className={clsx(
            "text-xs font-regular",
            scaffold.page.colors.text.tertiary,
          )}
        >
          {dayjs(contract_start).format("MMMM YYYY")} {" - "}
          {dayjs(contract_end).format("MMMM YYYY")}
        </div>
      </div>
    );
  }, [
    planName,
    scaffold.page.colors.text.tertiary,
    contract_start,
    contract_end,
  ]);
  useHeaderTitle(title);

  if (allDocuments.isSuccess && !documents) {
    const Navigate = scaffold.system.navigate;
    return <Navigate to="/account/documents/" />;
  }

  const PageBody = scaffold.page.pageBody;
  return (
    <PageBody>
      <QueryLoader
        queries={[allDocuments]}
        errorMessage="Failed loading documents. Please try again later."
      >
        <div className="pt-8">
          <DocumentList
            efl={documents?.efl}
            yrac={documents?.yrac}
            tos={documents?.tos}
            hideBrokerTermsOfService
          />
        </div>
      </QueryLoader>
    </PageBody>
  );
};
